module.exports = __webpack_public_path__ + "static/media/foilNone.39c74e02.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/foilNone.svg
// module id = 603
// module chunks = 68